<template>
  <div>
    <div class="row" v-if="selected.length > 0">
      <div class="col-md-2">
        <button v-on:click="mark_selected_inactive" class="btn btn-danger">Mark Inactive</button>
      </div>
      <div class="col-md-2">
        <button v-on:click="mark_selected_active" class="btn btn-success">Mark Active</button>
      </div>
      <div class="col-md-2" v-if="org['curOrg']['role'] == 99">
        <button v-on:click="mark_selected_archived" class="btn btn-info">Archive</button>
      </div>
    </div>
    <br/>
    <div class="table-responsive">
      <table class="table table-hover">
          <thead>
              <tr>
                  <th v-if="org['curOrg']['role'] != '3'">
                    <label class="form-checkbox">
                      <input type="checkbox" v-model="selectAll" @change="select">
                      <i class="form-icon"></i>
                    </label>
                  </th>
                  <th v-for="key in columns"
                      @click="sortBy(key)"
                      :class="{ active: sortKey == key }">
                      {{ key | capitalize }}
                      <span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'">
                      </span>
                  </th>
              </tr> 
          </thead>
          <tbody>
              <tr v-for="entry in filteredData" :class="{'table-danger':!entry.active, 'table-success':entry.active}">
                  <td v-if="org['curOrg']['role'] != '3'">
                    <label class="form-checkbox">
                      <input type="checkbox" :value="entry['.key']" v-model="selected">
                      <i class="form-icon"></i>
                    </label>
                  </td>
                  <td>{{entry.name}}</td> 
                  <td v-if="entry.lastcompleted === ''">Never</td> 
                  <td v-else>{{entry.lastcompleted}}</td> 
                  <td v-if="entry.ranger != true">{{entry.nextdue}}</td>
                  <td v-else></td> 
                  <td v-if="entry.ranger != true">{{entry.timeleft}}</td>
                  <td v-else></td> 
                  <td><router-link class="btn btn-default" :to="'/operations/workflow/' + entry['.key']">More</router-link></td>
              </tr>
          </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import database from '../../webmaster/Database/database'
import store from '../../webmaster/Store/vuex'

export default {
  name: 'datatable',
   props: {
    data: Array,
    columns: Array,
    filterKey: String,
    url: String
  },
  data: function () {
    var sortOrders = {}
    this.columns.forEach(function (key) {
      sortOrders[key] = 1
    })
    return {
      sortKey: '',
      sortOrders: sortOrders,
      selected: [],
      selectAll: false,
      org: store.state.usermain
    }
  },
  computed: {
    filteredData: function () {
      var sortKey = this.sortKey
      var filterKey = this.filterKey && this.filterKey.toLowerCase()
      var order = this.sortOrders[sortKey] || 1
      var data = this.data
      if (filterKey) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      if (sortKey) {
        data = data.slice().sort(function (a, b) {
          a = a[sortKey]
          b = b[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }

      

      return data
    }
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  methods: {
    sortBy: function (key) {
      this.sortKey = key
      this.sortOrders[key] = this.sortOrders[key] * -1
    },
    select() {
			this.selected = [];
			if (this.selectAll) {
				for (let i in this.filteredData) {
					this.selected.push(this.filteredData[i]['.key']);
				}
			}
		},
    mark_selected_active: function(){
      var curOrgId = this.$store.state.usermain.curOrg.id
      var updates = {};
      this.selected.forEach(item => {
        updates['/orgs/' + curOrgId + '/workflows/' + item + '/active'] = true;
        updates['/orgs/' + curOrgId + '/meta_workflows/' + item + '/active'] = true;
      });
      database.getDb().ref().update(updates);
      this.selected = []
      this.selectAll = false
    },
    mark_selected_inactive: function(){
      var curOrgId = this.$store.state.usermain.curOrg.id
      var updates = {};
      this.selected.forEach(item => {
        updates['/orgs/' + curOrgId + '/workflows/' + item + '/active'] = false;
        updates['/orgs/' + curOrgId + '/meta_workflows/' + item + '/active'] = false;
      });
      database.getDb().ref().update(updates);
      this.selected = []
      this.selectAll = false
    },
    mark_selected_archived: function(){
      var curOrgId = this.$store.state.usermain.curOrg.id
      var updates = {};
      this.selected.forEach(item => {
        updates['/orgs/' + curOrgId + '/workflows/' + item + '/archived'] = true;
        updates['/orgs/' + curOrgId + '/meta_workflows/' + item + '/archived'] = true;

        updates['/orgs/' + curOrgId + '/workflows/' + item + '/active'] = false;
        updates['/orgs/' + curOrgId + '/meta_workflows/' + item + '/active'] = false;
      });
      database.getDb().ref().update(updates);
      this.selected = []
      this.selectAll = false
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
}
</style>



// WEBPACK FOOTER //
// WorkflowTable.vue?4a745730